{
  "PAYMENTS": {
    "UNSUPPORTED_COUNTRY_MESSAGE": "Your Stripe account is registered in an unsupported country. Connect an account from a supported country, or contact support for more information.",
    "CONNECTED_ACCOUNT_ALREADY_CLAIMED_MESSAGE": "This Stripe account is already connected to a different merchant. Disconnect it first, or connect a different Stripe account.",
    "DISCONNECT_IN_PROGRESS_MESSAGE": "Can't connect a Stripe account until the previous one finishes disconnecting. Try again in a few minutes."
  },
  "PRICING_COMMONS": {
    "STARTING_AT_LABEL": "Starting at",
    "MINIMUM_PRICE_LABEL": "Minimum",
    "FREE_LABEL": "Free",
    "CONTACT_SALES_LABEL": "Contact Sales",
    "SETUP_FEE_LABEL": "Setup fee",
    "MANAGEMENT_FEE_LABEL": "Management fee",
    "PRICE_UNAVAILABLE_LABEL": "Price unavailable",
    "VARIABLE_PRICE_INPUT": {
      "LABEL": "Enter amount",
      "ADD_NOTE": "Add note",
      "NOTE_LABEL": "Note"
    }
  },
  "SUBSIDIARY_CHANGE_WARNING": {
    "TITLE": "Re-enter your payment method",
    "WILL_REQUIRE_PAYMENT_METHOD": "Changing your billing contact's country may require you to re-enter a payment method.",
    "AVOID_TRANSACTION_DELAYS": "Ensure that you re-enter a payment method to avoid delaying future transactions.",
    "CONFIRM": "Confirm",
    "WARNING": "Warning"
  },
  "REFUND_DIALOG": {
    "TITLE": "Issue refund",
    "ORIGINAL_CHARGE": "The original charge was",
    "AMOUNT": "Refund amount",
    "REFUND_MUST_BE_GREATER_THAN_ZERO": "Refund must be greater than",
    "REFUND_CANNOT_EXCEED_AMOUNT": "Refund cannot exceed amount",
    "REASON_LABEL": "Reason",
    "REASON_LABEL_HINT": "Reason will not be visible to customer",
    "SELECT_REASON": "Select a reason",
    "REASON_REQUIRED": "Reason for refund required",
    "DETAILED_NOTES": "Detailed notes",
    "NOTES_REQUIRED": "Notes required",
    "NOTES_LABEL": "Notes",
    "NOTES_LABEL_HINT": "Notes will be visible to customer",
    "CANCEL": "Cancel",
    "CONFIRM": "Confirm"
  },
  "SUBSCRIPTIONS": {
    "FILTERS": {
      "SEARCH": "Search subscriptions",
      "FREQUENCY": {
        "ONE_TIME": "One Time",
        "MONTHLY": "Monthly",
        "YEARLY": "Yearly"
      },
      "DATE": {
        "ENDS_BEFORE": "Ends Before",
        "ENDS_AFTER": "Ends After"
      }
    },
    "EXPORT": {
      "SUCCESS": "Export started, you will receive a download notification when your file is ready",
      "ERROR": "Failed to start subscriptions export",
      "LABEL": "Export as CSV"
    }
  },
  "BILLING_CONTACT": {
    "TITLE": "Billing contact",
    "COMPANY_NAME": "Company name",
    "NAME": "Name",
    "EMAIL_ADDRESS": "Email address(es)",
    "EMAIL_DELIMITER": "Comma or semicolon separated",
    "EMAIL_REQUIRED_ERROR": "At least one email address is required",
    "EMAIL_INVALID_ERROR": "Email addresses entered must be valid: example@example.com",
    "PHONE_NUMBER": "Phone number",
    "ADDRESS": "Address",
    "COUNTRY": "Country",
    "CITY": "City",
    "PROVINCE": "State/Province",
    "POSTAL_CODE": "Zip/Postal code",
    "CANCEL": "Cancel",
    "SAVE": "Save",
    "SAVE_SUCCESS": "Successfully updated contact information.",
    "SAVE_ERROR": "Error updating contact information."
  },
  "CHARGE_INVOICE_DIALOG": {
    "TITLE": "Charge sales invoice ({{ number }})",
    "TOTAL": "Total amount:",
    "OUTSTANDING": "Outstanding balance:",
    "AMOUNT": "Amount",
    "CANCEL": "Cancel",
    "CHARGE": "Charge invoice",
    "ERROR_AMOUNT_IS_REQUIRED": "Amount is required",
    "ERROR_MINIMUM_AMOUNT": "Amount must be at least 50"
  },
  "PAYMENT_METHOD": {
    "UPDATE_SUCCESS": "Successfully updated payment method"
  },
  "MARK_PURCHASE_AS_PAID_DIALOG": {
    "TITLE": "Mark purchase as paid",
    "BODY": "Marking a purchase as paid will update the purchase status to succeeded. The system will not attempt to collect any payment for this purchase thereafter.",
    "CONFIRMATION": "Are you sure you want to proceed for purchase <strong>{{ purchaseId }}</strong>?",
    "CANCEL": "Cancel",
    "CONFIRM": "Mark as paid",
    "SUCCESS": "Purchase marked as paid",
    "ERROR": "Failed to mark purchase as paid"
  },
  "PURCHASE_ITEM_DETAILS": {
    "RESPONSE_TOO_LARGE": {
      "ERROR_TITLE": "An error occurred: ",
      "EXCLUDE_DETAILS_AUTO_FILTERED": "The response is too large, so purchase item details were filtered out. Export the table to see detailed data.",
      "EXPORT_REQUIRED": "The response is too large. Export the table to see detailed data."
    },
    "TOOLTIP": "Automatically applied when purchases contain too many items. Export the table to see purchase item details."
  },
  "BILLING": {
    "LOADING": "Loading",
    "CREDIT_NOTE_PAGE": {
      "CREATE_TITLE": "Create credit note",
      "CREDIT_NOTE_TITLE": "Credit note {{ creditNoteNumber }}",
      "NOT_FOUND": {
        "TITLE": "Credit note not found",
        "MESSAGE": "This credit note doesn't exist or is no longer available."
      },
      "INVOICE_NOT_FOUND": {
        "TITLE": "Invoice not found",
        "MESSAGE": "This invoice doesn't exist or is no longer available."
      },
      "ACCOUNT_NOT_FOUND": {
        "TITLE": "Account not found",
        "MESSAGE": "This account doesn't exist or isn't set up for billing in its market."
      },
      "CUSTOMER": "Customer",
      "CREATED_DATE": "Created",
      "CREDIT_AMOUNT": "Credit amount",
      "REASON": "Reason",
      "REASON_PLACEHOLDER": "Select reason for credit",
      "REASON_REQUIRED": "Reason for credit note required",
      "INTERNAL_NOTE": "Internal note",
      "INTERNAL_NOTE_PLACEHOLDER": "Enter note",
      "DUPLICATE_CHARGE": "Duplicate charge",
      "PRODUCT_UNSATISFACTORY": "Product unsatisfactory",
      "ORDER_CHANGE": "Order change",
      "OTHER": "Other",
      "CLIENT_CANCELLATION": "Client cancellation",
      "DISPUTED": "Disputed",
      "UNCOLLECTIBLE": "Uncollectible",
      "RETENTION": "Retention",
      "CUSTOMER_MEMO_SUBTITLE": "The memo will be visible to the customer at the bottom of the email",
      "PARTNER_MEMO_SUBTITLE": "The memo will be visible to the account at the bottom of the email",
      "APPLY_CREDIT_NOTE": "Apply credit note",
      "APPLY_AND_SEND": "Apply and send",
      "APPLY_AND_SEND_CREDIT_NOTE": "Apply and send credit note",
      "CREATE_DRAFT": "Create draft",
      "DRAFT_CREATED": "Credit note draft created",
      "STATUS_DRAFT": "Draft",
      "STATUS_ISSUED": "Issued",
      "STATUS_FULLY_APPLIED": "Fully applied",
      "REMAINING_BALANCE": "Remaining balance",
      "ISSUE_CREDIT_NOTE": "Issue credit note",
      "CREDIT_NOTE_ISSUED": "Credit note issued",
      "ERROR_ISSUE": "The credit note could not be issued. Please try again.",
      "ERROR_SAVE": "Your change to the credit note could not be saved. Please try again.",
      "SAVING_DRAFT": "Saving credit note…",
      "DRAFT_SAVED": "Credit note saved {{ timeAgo }}",
      "SEND_CREDIT_NOTE": "Send credit note",
      "SEND_CREDIT_NOTE_TO": "Send the credit note to",
      "SENT_CREDIT_NOTE": "Credit note sent successfully",
      "ERROR_SEND_AFTER_CREATE": "The credit note has been applied to the invoice, but the email could not be sent",
      "SUMMARY": {
        "INVOICE_TOTAL": "Invoice total including tax",
        "INVOICE_TOTAL_NO_TAX": "Invoice total",
        "SUBTOTAL": "Credit subtotal",
        "TOTAL": "Credit total",
        "REFUND": "Refund"
      },
      "CREDITED_INVOICE": "Credited invoice",
      "CREDITED_INVOICES": "Credited invoices",
      "INVOICE": "Invoice",
      "STATUS": "Status",
      "DUE_DATE": "Due date",
      "AMOUNT_CREDITED": "Amount credited",
      "AMOUNT_REMAINING": "Amount remaining",
      "REFUND": {
        "TITLE": "Refund method",
        "PLACEHOLDER": "Select refund method",
        "PAYMENT_METHOD_REFUND": "Refund payment method",
        "MANUAL_REFUND": "Refund manually (cash, cheque, etc.)"
      },
      "REFUND_METHOD_REQUIRED": "Refund method required",
      "REQUIRED_FIELDS_ERROR": "Please fill out all required fields",
      "TOTAL_EXCEEDS_INVOICE_AMOUNT_POPUP": "Credit total cannot be greater than invoice total",
      "TOTAL_EXCEEDS_INVOICE_AMOUNT_INFO": "Credit total cannot be greater than invoice total, adjust item credit amounts",
      "CREDIT_TOTAL_MINIMUM_POPUP": "Credit total cannot be zero",
      "CREDIT_TOTAL_MINIMUM_INFO": "Credit total cannot be zero, adjust item credit amounts",
      "ERROR_PAYMENT_PROCESSING": "Unable to apply a credit note while the invoice payment is processing",
      "ERROR_REFUND_BANK_ACCOUNT_UNUSABLE": "Credit note not created. The customer's bank account can't receive refunds. Contact support for help.",
      "ERROR_REFUND_FAILED": "Credit note not created. The refund failed. Try again or contact support.",
      "ERROR_MAYBE_APPLIED": "The credit note may have already been applied. Check the invoice before trying again.",
      "ERROR_NO_PAYMENT_METHOD": "No payment record found. Payments may have been collected manually (cash, cheque, etc.)",
      "ERROR_NO_PAYMENT_METHOD_POPUP": "No payment record found",
      "GENERIC_ERROR": "Something went wrong. Please try again."
    },
    "INVOICE_PAGE": {
      "CREDIT_NOTE_APPLIED": "Credit note applied to invoice"
    },
    "CREDIT_NOTE_ACTIVITY": {
      "TITLE": "Activity",
      "UNAVAILABLE": "Activity is unavailable right now.",
      "NO_ACTOR": "No actor recorded",
      "WAS": "(was {{ value }})",
      "ACTOR": {
        "VENDASTA": "Vendasta Support",
        "SYSTEM": "System",
        "VENDASTA_TAG": "Vendasta"
      },
      "SENTENCE": {
        "CREATED_WITH_AMOUNT": {
          "ACTIVE": "created credit note {{ number }} for {{ amount }}",
          "PASSIVE": "Credit note {{ number }} was created for {{ amount }}"
        },
        "CREATED": {
          "ACTIVE": "created the credit note",
          "PASSIVE": "The credit note was created"
        },
        "UPDATED": {
          "ACTIVE": "updated the credit note",
          "PASSIVE": "The credit note was updated"
        },
        "DELETED": {
          "ACTIVE": "deleted the credit note",
          "PASSIVE": "The credit note was deleted"
        },
        "ISSUED": {
          "ACTIVE": "issued the credit note",
          "PASSIVE": "The credit note was issued"
        },
        "EDITED_FIELD": {
          "ACTIVE": "edited the {{ field }}",
          "PASSIVE": "The {{ field }} was edited"
        },
        "CHANGED_FIELD_TO": {
          "ACTIVE": "changed the {{ field }} to {{ value }}",
          "PASSIVE": "The {{ field }} was changed to {{ value }}"
        },
        "APPLIED": {
          "ACTIVE": "applied {{ amount }} to invoice {{ number }}",
          "PASSIVE": "{{ amount }} was applied to invoice {{ number }}"
        },
        "APPLIED_TO_MANY": {
          "ACTIVE": "applied {{ amount }} across {{ count }} invoices",
          "PASSIVE": "{{ amount }} was applied across {{ count }} invoices"
        },
        "UPDATED_WITHOUT_DETAIL": {
          "ACTIVE": "made a change that isn't shown here",
          "PASSIVE": "A change was made that isn't shown here"
        },
        "ADDED_ITEM": {
          "ACTIVE": "added line item “{{ item }}”",
          "PASSIVE": "Line item “{{ item }}” was added"
        },
        "ADDED_ITEM_UNNAMED": {
          "ACTIVE": "added a line item",
          "PASSIVE": "A line item was added"
        },
        "REMOVED_ITEM": {
          "ACTIVE": "removed line item “{{ item }}”",
          "PASSIVE": "Line item “{{ item }}” was removed"
        },
        "REMOVED_ITEM_UNNAMED": {
          "ACTIVE": "removed a line item",
          "PASSIVE": "A line item was removed"
        },
        "CHANGED_ITEM_FIELD_TO": {
          "ACTIVE": "changed “{{ item }}” {{ field }} to {{ value }}",
          "PASSIVE": "“{{ item }}” {{ field }} was changed to {{ value }}"
        },
        "CHANGED_ITEM_FIELD_TO_UNNAMED": {
          "ACTIVE": "changed a line item's {{ field }} to {{ value }}",
          "PASSIVE": "A line item's {{ field }} was changed to {{ value }}"
        },
        "EDITED_ITEM": {
          "ACTIVE": "edited line item “{{ item }}”",
          "PASSIVE": "Line item “{{ item }}” was edited"
        },
        "EDITED_ITEM_UNNAMED": {
          "ACTIVE": "edited a line item",
          "PASSIVE": "A line item was edited"
        },
        "EDITED_ITEMS": {
          "ACTIVE": "edited {{ count }} line items",
          "PASSIVE": "{{ count }} line items were edited"
        }
      },
      "FIELD": {
        "NUMBER": "number",
        "MEMO": "memo",
        "AMOUNT": "amount",
        "CURRENCY": "currency",
        "REASON": "reason",
        "TYPE": "type",
        "APPLIED_TO": "applied credits",
        "DELETED": "deleted date",
        "STATUS": "status",
        "ISSUED": "issued date",
        "APPLIED_AMOUNT": "applied amount",
        "NOTES": "internal note",
        "TAX": "tax",
        "UNSPECIFIED": "credit note"
      },
      "ITEM_FIELD": {
        "DESCRIPTION": "description",
        "QUANTITY": "quantity",
        "PRICE": "price"
      },
      "ITEM_DETAIL": {
        "ADDED": "Added “{{ item }}”",
        "ADDED_UNNAMED": "Added a line item",
        "REMOVED": "Removed “{{ item }}”",
        "REMOVED_UNNAMED": "Removed a line item",
        "FIELD": "“{{ item }}” {{ field }}",
        "FIELD_UNNAMED": "Line item {{ field }}"
      },
      "STATUS": {
        "DRAFT": "Draft",
        "ISSUED": "Issued",
        "FULLY_APPLIED": "Fully applied"
      },
      "APPLIED_TO_INVOICE": "Applied to invoice {{ invoice }}",
      "APPLIED_TO_UNKNOWN": "Applied to an invoice"
    }
  },
  "RETAIL_PROVIDER_DISCONNECT": {
    "BUTTON": "Disconnect Stripe account",
    "CONFIRM_TITLE": "Disconnect Stripe account?",
    "CONFIRM_MESSAGE": "This will remove Stripe details from each of your customers, and you will no longer be able to refund past payments. This can't be undone.",
    "CONFIRM_CTA": "Disconnect",
    "ERROR": "Couldn't disconnect the Stripe account. Try again in a few moments.",
    "SCENE": {
      "OPENING_TITLE": "Getting ready",
      "QUIESCE_TITLE": "Turning off payments",
      "QUIESCE_STATUS": "New payments are no longer accepted",
      "FINDING_TITLE": "Finding customers",
      "FINDING_STATUS": "This can take a few minutes",
      "CLEARING_TITLE": "Clearing Stripe details from customers",
      "COUNT": "{{processed}} of {{total}} cleared",
      "RELEASE_TITLE": "Disconnecting account",
      "RELEASE_STATUS": "This only takes a moment",
      "DONE_TITLE": "Stripe account disconnected",
      "DONE_STATUS": "You can connect a different account anytime",
      "FAILED_TITLE": "Disconnect didn't finish",
      "FAILED_STATUS": "Some customers may still have Stripe details. Try disconnecting again.",
      "DISMISS": "Close"
    }
  }
}
